import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Dropdown,
  Popconfirm,
  Select,
  Table,
  Tooltip,
} from 'antd';
import {useState} from 'react';
import toast from 'react-hot-toast';
import {useSelector} from 'react-redux';

import {
  RQDeletePromocodeAPI,
  RQGetPromocodeAPI,
  RQUpdatePromocodeAPI,
} from '../../../reactQuery/apis';
import {selectAuth} from '../../../redux/selectors';

import {PromocodeModal} from './PromocodeModal';

const {Option} = Select;

const ProductPromocode = () => {
  const auth = useSelector(selectAuth);
  const token = auth?.tokenData;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [updatePromocodeData, setUpdatePromocodeData] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const {
    data: promocodeData = [],
    isLoading,
    refetch,
  } = RQGetPromocodeAPI(token);

  const {mutate: updatePromocode} = RQUpdatePromocodeAPI({
    onSuccess: () => {
      toast.success('Promocode updated successfully');
      refetch();
      setIsModalVisible(false);
    },
    onError: error => {
      toast.error(error?.message || 'Something went wrong');
    },
  });

  const {mutate: deletepromo} = RQDeletePromocodeAPI({
    onSuccess: () => {
      toast.success('Promocode deleted');
      refetch();
    },
  });

  const handleStatusChange = (record, newStatus) => {
    updatePromocode({
      token,
      id: record.id,
      formData: {
        code: record.code, 
        discountValue: record.discountValue,
        isActive: newStatus === 'ACTIVE',
      },
    });
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'srno',
      width: 80,
    },
    {
      title: 'Promocode',
      dataIndex: 'code',
    },
    {
      title: 'Discount (%)',
      dataIndex: 'discountValue',
      width: 140,
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      width: 120,
      render: (isActive, record) => (
        <Dropdown
          trigger={['click']}
          menu={{
            onClick: e => handleStatusChange(record, e.key),
            items: [
              !isActive && {key: 'ACTIVE', label: 'Activate'},
              isActive && {key: 'INACTIVE', label: 'Inactivate'},
            ].filter(Boolean),
          }}
        >
          <span className={'cursor-pointer font-medium'}>
            {isActive ? 'ACTIVE' : 'INACTIVE'}
          </span>
        </Dropdown>
      ),
    },
    {
      title: 'Action',
      width: 120,
      render: (_, record) => (
        <>
          <div className={'flex gap-6'}>
            <EditOutlined
              onClick={() => {
                setUpdatePromocodeData(record);
                setIsModalVisible(true);
              }}
            />
            <Tooltip title={'Delete'}>
              <Popconfirm
                title={'Are you sure you want to delete this Promocode?'}
                onConfirm={() => deletepromo({token, id: record.id})}
                okText={'Yes'}
                cancelText={'No'}
              >
                <DeleteOutlined
                  className={'text-red-500'}
                /> 
              </Popconfirm>
             
            </Tooltip>
          </div>
          {/* 
          <div className={'flex'}>
            <Button  className={' mr-2'}>
              <EditOutlined
                className={'cursor-pointer mr-2'}
                onClick={() => {
                  setUpdatePromocodeData(record);
                  setIsModalVisible(true);
                }}
              />
            </Button>

            <Tooltip title={'Delete'}>
              <Popconfirm
                title={'Are you sure you want to delete this User?'}
                onConfirm={() => deletepromo({token, id: record.id})}
                okText={'Yes'}
                cancelText={'No'}
              >
                <Button danger icon={<DeleteOutlined />} />
              </Popconfirm>
          
            </Tooltip>
          </div> */}

        </>
        
      ),
    },
  ];

  const filteredData = promocodeData.filter(promocode => {
    if (selectedStatus === 'ACTIVE') {return promocode.isActive;}
    if (selectedStatus === 'INACTIVE') {return !promocode.isActive;}
    return true;
  });

  const formattedPromocodeData = filteredData.map((promoCode, index) => ({
    key: promoCode.id,
    id: promoCode.id,
    srno: index + 1,
    code: promoCode.code,                 
    discountValue: promoCode.discountValue,
    isActive: promoCode.isActive,
  }));

  return (
    <div>
      <Breadcrumb
        className={'hidden lg:block'}
        items={[{title: 'Home'}, {title: 'Promocode'}]}
      />

      <div className={'flex justify-between items-center mt-4'}>
        <h1 className={'font-bold text-lg'}>Promocode List</h1>
        
      </div>

      <div className={'flex gap-2 mt-4'}>
        <Select
          placeholder={'Select status'}
          allowClear
          className={'w-48'}
          value={selectedStatus}
          onChange={value => setSelectedStatus(value)}
        >
          <Option value={'ACTIVE'}>Active</Option>
          <Option value={'INACTIVE'}>Inactive</Option>
        </Select>
      </div>

      <div className={'mt-4'}>
        <Button
          type={'primary'}
          onClick={() => {
            setUpdatePromocodeData(null);
            setIsModalVisible(true);
          }}
        >
          <PlusOutlined /> Add Promocode
        </Button>
      </div>

      <div className={'mt-4 overflow-x-auto'}>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={formattedPromocodeData}
          pagination={{pageSize: 10}}
        />
      </div>

      <PromocodeModal
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        refetch={refetch}
        updatePromocodeData={updatePromocodeData}
      />
    </div>
  );
};

export default ProductPromocode;
